// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
var hasFieldRecord = function (dictIsSymbol) {
    return function () {
        return {
            getField: function (label) {
                return $foreign.unsafeGet(Data_Symbol.reflectSymbol(dictIsSymbol)(label));
            }
        };
    };
};
var getField = function (dict) {
    return dict.getField;
};
export {
    getField,
    hasFieldRecord
};
//# sourceMappingURL=index.js.map
